import type { ComponentType } from 'react';

export const MEIN_ORT_FEED_ROUTE = 'feed';

export enum MeinOrtChannel {
  FUNKZENTRALE = 'funkzentrale',
  GRUPPEN = 'gruppen',
  INFOS = 'infos'
}

export enum MeinOrtTab {
  ALLE = 'alle',
  NEWS = 'news',
  PLAUSCH = 'plausch',
  MARKT = 'markt',
  EVENTS = 'events',
  GRUPPEN = 'gruppen',
  CHATS = 'chats',
  SAGSUNS = 'sagsUns',
  TERRITORIAL_AUTHORITY = 'territorialAuthority',
  VEREINE = 'vereine',
  EHRENAMT = 'ehrenamt',
  SCHULEN = 'schulen',
  KIRCHE = 'kirche'
}

export type SvgIconProps = { fill?: string; width?: number; height?: number };

export type MeinOrtPageTab = {
  key: MeinOrtTab;
  label: string;
  icon: ComponentType<SvgIconProps>;
  dot?: boolean;
};

export type MeinOrtChannelConfig = {
  key: MeinOrtChannel;
  label: string;
  tabs: MeinOrtPageTab[];
};
